// extracted by mini-css-extract-plugin
export var lg = "_f7-7";
export var md = "_f7-6";
export var placeholderContainer = "_f7-1";
export var placeholderIcon = "_f7-2";
export var productImage = "_f7-0";
export var sm = "_f7-5";
export var xl = "_f7-8";
export var xs = "_f7-4";
export var xxs = "_f7-3";